module.exports = __webpack_public_path__ + "img/chadle_adv_15.fae53d91.png";